import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { BehaviorSubject, Observable } from "rxjs";
import { retry, timeout } from "rxjs/operators";
import {
  PrintersStatus,
  PrintingObject,
  RNPrinterStatus,
} from "src/app/models/printing.model";
import { resolveHostedUrl } from "src/app/constants/hosted-api-urls";
import { LocalStorageService } from "./localStorage.service";
declare function send_data(params: string): any;

@Injectable({
  providedIn: "root",
})
export class PrintService {
  printQueue: PrintingObject[] = []; //expects event data
  printerStatusQueue: any = [];
  ongoingQueue: PrintingObject[] = [];
  isPrintingFromQueue: boolean = false;
  isCheckingFromQueue: boolean = false;
  printers: PrintersStatus[] = [];
  successfulDelayPrintingIds = [];
  printersList$: BehaviorSubject<any> = new BehaviorSubject<any>(this.printers);
  allDelayPrintEvents$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  successfulDelayPrintingIds$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  isUpdatingPrinters: boolean = false;
  lastPrintAttemptTime: number = Date.now();
  lastCheckAttemptTime: number = Date.now();
  printQueueThreshold: number = 15;
  minWaitTimeBetweenPrint: number = 500;
  maxWaitForOngoingPrint: number = 2000;
  maxWaitForOngoingPrinterStatus: number = 10000;
  pollingIntervalForFetchEventsAPI: number = 5000;
  pollNextPrintEvent: number = 200;
  pollingIntervalPrinterStatus: number = 30000;
  lastPrinterListUpdatedTime: number = Date.now();
  printDebugMessages: boolean = false;
  printEnabled: boolean = false;
  isPrintPollingWebEnabled: boolean = false;
  _printV2FromRN: boolean = false;
  _appVersion: string = '';
  reprintEnabled: boolean = false;
  delayPrintEnabled: boolean = false;
  isDelayPrintPollingAlreadyStarted: boolean = false;
  printIntervalId;
  deviceId: string = "";
  initUpdatePrinter: boolean = true;

  private _isReactDevice: boolean;
  isRealmEnabled: boolean = false;
  public get isReactDevice(): boolean {
    return this._isReactDevice;
  }
  public set isReactDevice(value: boolean) {
    this._isReactDevice = value;
  }

  public get printV2FromRN(): boolean {
    return this._printV2FromRN;
  }
  public set printV2FromRN(value: boolean) {
    this._printV2FromRN = value;
  }
  public get appVersion(): string {
    return this._appVersion || this._localStorage.get('app_version') || '';
  }
  public set appVersion(value: string) {
    this._appVersion = value || '';
    if (value) {
      this._localStorage.set('app_version', value);
    }
  }

  private _isStarted: boolean = false;
  public get itStarted(): boolean {
    return this._isStarted;
  }
  public set itStarted(value: boolean) {
    this._isStarted = value;
  }

  private _print_rest_Id: any;
  public get print_rest_Id(): any {
    return this._print_rest_Id;
  }
  public set print_rest_Id(value: any) {
    //todo: update printers list for restaurant
    this._print_rest_Id = value;
    this.updatePrintersList();
    this.setDeviceId();
  }

  private _print_rest_settings: any;
  public get print_rest_settings(): any {
    return this._print_rest_settings;
  }
  public set print_rest_settings(value: any) {
    this._print_rest_settings = value;
    this.isPrintPollingWebEnabled = !!(value?.print?.is_print_polling_web_enabled);
    if (value && value.global) {
      this.printDebugMessages = value.global.print_debug_messages ? true : false;
      this.printEnabled = value.global.print_v2_enabled ? true : false;
      this.reprintEnabled = value.global.reprint_enabled ? true : false;
      this.delayPrintEnabled = value.global.is_show_delay_print ? true : false;
      this.isRealmEnabled = value.global.is_realm_enabled ? true : false ;
      let data = { action: "init_print_queue" };
      send_data(JSON.stringify(data));
      this.setDeviceId();
      if (this.printEnabled && this.initUpdatePrinter) {
        this.initUpdatePrinter = false;
        this.updatePrintersList();
      }
      if(this.delayPrintEnabled && !this.isDelayPrintPollingAlreadyStarted) {
        this.updateDelayPrintInterval();
      }
    }
  }

  public get allPrinters() {
    return this.printers;
  }

  constructor(
    private _http: HttpClient,
    private messageService: NzMessageService,
    private _localStorage: LocalStorageService,
  ) {
    this._appVersion = this._localStorage.get('app_version') || '';
    //Todo: correct the names
    window["getPrinterStatusReference"] = {
      getPrintAcknowldegeStatus: (response: any) => {
        this.isPrintingFromQueue = false;
        this.printFromQueue();
        //todo: form acknowledgement payload and send to acknowledgement api
        if (this.printDebugMessages) {
          this.messageService.success(
            `Success for ${response.printing_id} with status ${response.printer_status}`
          );
        }

        if (
          this.delayPrintEnabled &&
          (response || {}).is_printed_manually &&
          !this.successfulDelayPrintingIds.includes(response.printing_id)
        ) {
          this.successfulDelayPrintingIds.push((response || {}).printing_id);
          this.sendSuccessfulDelayPrintingIds(this.successfulDelayPrintingIds);
        }

        if (response.printer_status === 1) {
          if (this.printDebugMessages) {
            this.messageService.success("hitting Acknowledgement API");
          }
          this.acknowledgePrintEvent({
            printing_id: response.printing_id,
            printed: true,
          }).pipe(timeout(5000), retry(2)).
          subscribe((res) => {
            this.ongoingQueue = this.ongoingQueue.filter(obj => obj.event_data.printing_id !== response.printing_id)

            // Todo: further add failure logics in V2
            // this.messageService.success(
            //   "posted acknowledgement:" + res.success
            // );
          });

        } else {
          this.ongoingQueue = this.ongoingQueue.filter(obj => obj.event_data.printing_id !== response.printing_id)

          //send a negative acknowledgement after 4 minutes
          //to be done in v2
        }
      },
      updatePrinterStatus: (printerStatus: RNPrinterStatus) => {
        //TODO: revisit
        this.printers.forEach((item) => {
          if (item.ip === printerStatus.ip) {
            item.isConnected = printerStatus.printer_status === 1;
            if (item.retryTimeoutRef && printerStatus.printer_status === 1) {
              clearTimeout(item.retryTimeoutRef);
              item.retryTimeoutRef = null;
            }
            item.isRetrying = false;
          }
        });
        this.isCheckingFromQueue = false;
        this.sendPrinterListData(this.printers);
        this.checkForPrinterStatus();
      },
      displayPrinterStatus: (statusData: any) => {
        console.log(statusData);
        if ((statusData.counter_id || statusData.counter_id === '') && this.print_rest_Id) {
          const data = {
            restaurant_id: this.print_rest_Id,
            counter_id: statusData.counter_id || 'master',
            acknowledgement: statusData.printer_status
          };
          this._http.post<any>(
            `${resolveHostedUrl('nestURL')}/api/print/acknowledge`, data
          ).subscribe((res) => {
            console.log(res);
          });
        }
        if (this.printDebugMessages) {
          this.messageService.success(
            `Status ${statusData.printer_status} for data ${JSON.stringify(statusData)}`
          );
        }
      },
      queueEnabled: (_statusData: any) => {
        if (this.printDebugMessages) {
          this.messageService.success(
            'Queue Enabled'
          );
        }
      },
      setDeviceId: (deviceId) => {
        if (this.printDebugMessages) {
          this.messageService.success(
            `Device ID is ${deviceId}`
          );
        }
        this.deviceId = deviceId;
        if (this.deviceId) {
          this._localStorage.set('deviceId', this.deviceId);
        }
      },
    };
    window.addEventListener('make_device_default', (event) => {
      this.setDeviceAsDefault();
    });
    let data = { action: "init_print_queue" };
    send_data(JSON.stringify(data));
    this.setDeviceId();
    this.startPolling();
  }

  setDeviceId() {
    send_data('{"action":"get_uniqueDeviceID"}');
  }

  startPolling() {
    setInterval(() => {
      this.toPoll();
    }, this.pollingIntervalForFetchEventsAPI);
    setInterval(() => {
      this.printFromQueue();
      this.checkForPrinterStatus();
    }, this.pollNextPrintEvent);

    setInterval(() => {
      this.checkPrinterStatus();
    }, this.pollingIntervalPrinterStatus);

    this.updateDelayPrintInterval();
  }

  // Function to start or stop the interval based on delayPrintEnabled
  updateDelayPrintInterval() {
  if (this.delayPrintEnabled) {
    const isOnlineApp = !this.isRealmEnabled && this._localStorage.get('is_react') === '1';
    if(isOnlineApp) {
      this.isDelayPrintPollingAlreadyStarted = true;
      this.getAllDelayPrintEventsDataFromApi(); // call this api first time;
        // polling interval of 30 seconds
         this.printIntervalId = setInterval(() => {
            this.getAllDelayPrintEventsDataFromApi();
        }, this.pollingIntervalPrinterStatus);
    }
  } else {
    this.isDelayPrintPollingAlreadyStarted = false;
      // Clear the interval if delayPrintEnabled is false
      if(this.printIntervalId) {
        clearInterval(this.printIntervalId);
      }
  }
}

  toPoll() {
    if (
      this._isStarted &&
      this.isReactDevice &&
      !this.isRealmEnabled &&
      !this.printV2FromRN &&
      this.isPrintPollingWebEnabled
    ) {
      if (
        this.print_rest_Id &&
        this.print_rest_settings &&
        this.printEnabled &&
        this.printQueue.length < this.printQueueThreshold
      ) {
        let printer_ids = this.printers
          .filter((item) => item.isConnected == true)
          .map((item) => item.id);
        this.fetchAllPrintEventUsingPOST(
          this.print_rest_Id,
          printer_ids
        ).subscribe((response) => {
          if (response.success === true) {
            if (this.printDebugMessages) {
              this.messageService.success("Got some print event");
            }
            response.data.forEach((data) => {
              if (!this.printQueue.find((obj) => obj.event_data.printing_id === data.event_data.printing_id) && !this.ongoingQueue.find((obj) => obj.event_data.printing_id === data.event_data.printing_id)) {
                this.printQueue.push({
                  event_data: data.event_data,
                  print_data: data.print_data,
                  reprint_data: data.reprint_data ? data.reprint_data : [],
                });
              }
            });
          }
        },(error)=>{
          console.error(error);
        });
      }
    }
  }

  printFromQueue() {
    if (
      this.isPrintingFromQueue &&
      Date.now() - this.lastPrintAttemptTime >= this.maxWaitForOngoingPrint
    ) {
      this.isPrintingFromQueue = false;
    }
    if (
      !this.isUpdatingPrinters &&
      !this.isPrintingFromQueue &&
      this.printQueue.length > 0
    ) {
      this.isPrintingFromQueue = true;
      this.lastPrintAttemptTime = Date.now();
      let printObjAndID = this.printQueue.shift();
      this.ongoingQueue.push(printObjAndID);
      let print_data = printObjAndID.print_data;
      for (let itm of print_data) {
        for (let printer of this.printers) {
          if (printer.id === itm["ptr_id"] && !(itm["ptr_name"] === printer.ip)) {
            itm["ptr_name"] = printer.ip;
          }
        }
      }
      // Comparing with attempt_count >= 1 as it's starts with initial value as 0
      let printData = printObjAndID.print_data;
      if (this.reprintEnabled && (printObjAndID.event_data || {}).attempt_count >= 1 && printObjAndID.reprint_data && printObjAndID.reprint_data.length > 0 ) {
        printData = printObjAndID.reprint_data;
      }

      // Include the 'is_printed_manually' key in the data obj if the print-delay feature is enabled.
      let data = {
        action: "new_print_format",
        print_data: printData,
        order_id: printObjAndID.event_data.order_id,
        type: 0,
        printing_id: printObjAndID.event_data.printing_id,
        print_status: 0,
        ...(printObjAndID.manually_print ? { is_printed_manually: true } : {})
      };      
      let x = JSON.stringify(data);
      if (this.printDebugMessages) {
        this.messageService.success(
          "Sending Print event to React native" + data.printing_id
        );
      }

      send_data(x);
      //TODO: work on Acknowledgement logic
    }
  }
  //Todo: ensure proper escaping of strings
  // Need to use join in printer_ids as it is a comma-separated string
  fetchAllPrintEvent(rest_id, printer_ids) {
    return this._http.get<any>(
      `${resolveHostedUrl('nestURL')}/api/print?restaurant_id=${rest_id}&printer_ids=${printer_ids}`
    );
  }

  getDelayPrintingData(restId) {
    const url = `${resolveHostedUrl('nestURL')}/api/print/pending-events?restaurant_id=${restId}`;
    return this._http.get<any>(url);
  }

  getAllDelayPrintEventsDataFromApi() {
    this.getDelayPrintingData(this._localStorage.get('restaurant_id'))
      .subscribe((response: any) => {
        this.successfulDelayPrintingIds = []; // clear all existing successful printing ids
        const data = response.data;
        this.sendAllDelayPrintEventsData(data);
      });
  }

  // Fetch all print events using POST
  fetchAllPrintEventUsingPOST(rest_id, printer_ids) {
    let exclude_printing_ids = []; // Printing IDs which are already there in printQueue and ongoingQueue
    this.printQueue.forEach((item) => {
      if (!exclude_printing_ids.includes(item.event_data.printing_id)) {
        exclude_printing_ids.push(item.event_data.printing_id);
      }
    });
    this.ongoingQueue.forEach((item) => {
      if (!exclude_printing_ids.includes(item.event_data.printing_id)) {
        exclude_printing_ids.push(item.event_data.printing_id);
      }
    });
    const body = {
      // order_id: "", When need to search based on order.
      restaurant_id: rest_id,
      printer_ids: printer_ids,
      exclude_printing_ids: exclude_printing_ids,
      is_print_v2_from_rn : this.printV2FromRN,
      app_version: this.appVersion
    };
    if (this.deviceId) {
      body['device_uid'] = this.deviceId;
    } else {
      // Implementing this logic to set device id again if it is coming as null from react native
      this.setDeviceId()
      body['device_uid'] = '';
    }
    return this._http.post<any>(
      `${resolveHostedUrl('nestURL')}/api/print/fetch`, body
    );
  }

  // API method for acknowlegding print
  acknowledgePrintEvent(payload) {
    return this._http.put<any>(`${resolveHostedUrl('nestURL')}/api/print`, payload);
  }

  checkPrinterStatus() {
    // Also Trigger Printer List Update if last update was more than 5 minutes ago
    if (Date.now() - this.lastPrinterListUpdatedTime >= 120000) {
      this.updatePrintersList();
    }
    this.printers.forEach((item) => {
      if (!this.printerStatusQueue.find(o => o.ip === item.ip)) {
        this.printerStatusQueue.push(
          {
            action: "printer_status",
            ip: item.ip,
          }
        );
      }
    });
  }

  checkForPrinterStatus() {
    if (
      this.isCheckingFromQueue &&
      Date.now() - this.lastCheckAttemptTime >= this.maxWaitForOngoingPrinterStatus
    ) {
      this.isCheckingFromQueue = false;
    }
    if (
      !this.isCheckingFromQueue &&
      this.printerStatusQueue.length > 0
    ) {
      this.isCheckingFromQueue = true;
      this.lastCheckAttemptTime = Date.now();
      let obj = this.printerStatusQueue.shift();
      let x = JSON.stringify(obj);
      send_data(x);
    }
  }

  updatePrintersList() {
    //TODO: Ensure updating printers doesn't remain stuck
    this.isUpdatingPrinters = true;
    this.lastPrinterListUpdatedTime = Date.now();
    if (this.print_rest_Id && this.printEnabled) {
      const deviceId = this._localStorage.get('deviceId') || '';
      this._http
        .get<any>(
          `${resolveHostedUrl('nestURL')}/api/restaurant/active-printers/${this.print_rest_Id}?device_id=${deviceId}`
        )
        .subscribe(
          (response) => {
            if (response.statusCode === 200 && response.data) {
              let tempPrinterList = [];
              for (let key in response.data) {
                //Approximate test for checking if the IP is valid
                if (response.data[key].includes(":")) {
                  tempPrinterList.push({
                    id: key,
                    ip: response.data[key],
                    isConnected: this.getLastPrintingConnectionStatus(response.data[key] , key),
                    isRetrying : this.getValueIsRetryingValueIfExist(key)
                  });
                }
              }
              // TODO: Only update if list has changed
              this.printers = tempPrinterList;
              this.sendPrinterListData(this.printers);
            }
            this.checkPrinterStatus();
            this.isUpdatingPrinters = false;
          },
          (err) => {
            this.isUpdatingPrinters = false;
          }
        );
    }
  }

  getLastPrintingConnectionStatus(ipAddress : string , id : string) {
    let isConnected = false;
    if (ipAddress && id && this.printers.length > 0){
      let obj = this.printers.find((obj : PrintersStatus) => obj.ip == ipAddress &&  obj.id == id);
      if(obj){
        isConnected = obj.isConnected || false
      }
    }
    return isConnected;
  }

  getValueIsRetryingValueIfExist(id : string) {
    let isRetrying = false;
    if (id && this.printers.length > 0){
      let obj = this.printers.find((obj : PrintersStatus) => obj.id == id);
      if(obj){
        isRetrying =  obj.isRetrying || false
      }
    }
    return isRetrying;
  }

  setDeviceAsDefault() {
    const body = {
      restaurant_id: this.print_rest_Id,
      uid: this.deviceId
    };
    this._http.post<any>(
      `${resolveHostedUrl('nestURL')}/api/restaurant/default-device`, body
    ).subscribe((res) => {
      if (this.printDebugMessages) {
        // TODO: Handle error case as well
        this.messageService.success(`Made device ${this.deviceId} as default ${res.statusCode}`);
      }
    });
  }

  sendPrinterListData(message: PrintersStatus[]) {
    this.printersList$.next(message);
  }

  getAllPrinterListData():Observable<any> {
    return this.printersList$.asObservable();
  }

  sendAllDelayPrintEventsData(message) {
    this.allDelayPrintEvents$.next(message);
  }

  getAllDelayPrintEventsData():Observable<any> {
    return this.allDelayPrintEvents$.asObservable();
  }


  sendSuccessfulDelayPrintingIds(message) {
    this.successfulDelayPrintingIds$.next(message);
  }

  getSuccessfulDelayPrintingIds():Observable<any> {
    return this.successfulDelayPrintingIds$.asObservable();
  }

  sendPrintStatusToRN(payload){
    let data = JSON.stringify(payload);
    send_data(data);
  }

  get allPrinterStatus() {
    return this.printers;
  }

  pushManuallyDelayPrintEventsInPrintQueue(allPrinterEventsData) {
  
    (allPrinterEventsData || []).forEach((newPrintDelayEventData) => {
      if (newPrintDelayEventData && newPrintDelayEventData.event_data) {
        const newPrintingId = newPrintDelayEventData.event_data.printing_id || '';
  
        // Check if the printing_id doesn't already exist in the printQueue or ongoingQueue
        const isPrintingIdAlreadyInPrintQueue = this.printQueue.some(
          (obj) => obj.event_data && obj.event_data.printing_id === newPrintingId
        );
        const isPrintingIdAlreadyInOngoingQueue = this.ongoingQueue.some(
          (obj) => obj.event_data && obj.event_data.printing_id === newPrintingId
        );
  
        if (!isPrintingIdAlreadyInPrintQueue && !isPrintingIdAlreadyInOngoingQueue) {
          // Push the newData into the printQueue
          this.printQueue.push({ ...newPrintDelayEventData, manually_print: true });
        } else {
          console.warn(`Printing_id ${newPrintingId} is already in the queue.`);
        }
      }
    });
  }
}
